<template>
  <div
    :class="[$style.asset, data?.link && $style.link]"
    data-search-results-asset-v="3.0.1"
    @click="(e) => $handleBlockLinkClick(e, cardLinkEl?.$el)"
  >
    <AspectRatio ratio="1x1">
      <BasePicture
        v-if="data?.image?.fields?.file?.url"
        :src="`${data?.image?.fields?.file?.url}?fit=pad&q=90&w=480&h=480&bg=rgb:ffffff`"
        alt=""
      />
    </AspectRatio>

    <BaseHeading size="h7" :class="$style.title">
      <NuxtLinkLocale
        v-if="data?.link"
        ref="cardLink"
        :to="data?.link"
        :class="$style.titleLink"
        target="_blank"
      >
        {{ data?.title }}
      </NuxtLinkLocale>
      <template v-else>
        {{ data?.title }}
      </template>
    </BaseHeading>

    <CallToAction
      v-if="data?.cta"
      :cta="{
        ...data.cta,
        fields: {
          ...data.cta.fields,
          size: 'default',
        },
      }"
      :class="$style.button"
    />
  </div>
</template>

<script setup lang="ts">
import type { Asset } from 'contentful'
import type { TypeCallToActionWithoutUnresolvableLinksResponse } from '~/types/contentful'

const { $handleBlockLinkClick } = useNuxtApp()

const cardLinkEl = useTemplateRef<ComponentPublicInstance | null>('cardLink')

export type TypeResultAssetData = {
  sys?: {
    contentType: {
      sys: {
        id: 'product' | 'downloadableAsset' | undefined
      }
    }
    id: string | undefined
  }
  id?: string | undefined
  title?: string | undefined
  image?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined
  cta?: TypeCallToActionWithoutUnresolvableLinksResponse | undefined
  link?: string | undefined
}

defineProps<{
  data: TypeResultAssetData
}>()
</script>

<style lang="scss" module>
.asset {
  height: 100%;
  padding: 17px 15px;
  background: #ffffff;
  border: 1px solid rgba(#000, 0.04);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link {
  cursor: pointer;

  &:hover,
  &:focus {
    border: 1px solid rgba(#000, 0.12);
  }
}

.title {
  margin: 20px 0;
}

.titleLink {
  color: inherit;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }
}

.button {
  margin-top: auto;
}
</style>
